module.exports = __webpack_public_path__ + "static/img/class_6.dda0c5db.jpg";